export const B2bRoute = "/hd/b2b-energiebeschaffung";
